import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DevicesDevicesService } from '../../../services/devices-services/devices-devices-services/devices-devices.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { EMPTY, Subscription } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { delay } from 'rxjs/internal/operators/delay';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-device-list-status',
  templateUrl: './device-list-status.component.html',
  styleUrls: ['./device-list-status.component.scss']
})
export class DeviceListStatusComponent implements OnInit, OnDestroy {

  @Input() deviceInfo;
  updateBrightnessSubscription: Subscription;
  updateVolumeSubscription: Subscription;
  lockSubscription: Subscription;
  unlockSubscription: Subscription;
  editing: boolean;
  editingPropertie;
  waitingUpdate;
  newConnection;
  lastConnection;

  constructor(private snackbarService: SnackBarService,
    private devicesService: DevicesDevicesService) {
    this.editing = false;
    this.editingPropertie = { editing: false, propertie: '' };
  }

  ngOnInit() { }

  public toggleEdition() {
    this.editing = !this.editing;
  }

  public editPropertie(propertie) {
    this.editingPropertie.editing = !this.editingPropertie.editing;
    this.editingPropertie.propertie = propertie;
  }

  public editingThisPropertie(propertie) {
    if (this.editingPropertie.editing && (this.editingPropertie.propertie === propertie)) {
      return true;
    } else {
      return false;
    }
  }

  public brightnessChanged(e) {
    this.deviceInfo.Brightness = e.value;
  }

  public volumeChanged(e) {
    this.deviceInfo.Volume = e.value;
  }

  public updateBrightness() {
    this.updateBrightnessSubscription = this.devicesService.updateBrightness(this.deviceInfo.InternalId, this.deviceInfo.Brightness).pipe(
      tap(o => this.editPropertie('brightness')),
      delay(2000),
      tap(o => this.devicesService.refreshDevice()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public updateVolume() {
    this.updateVolumeSubscription = this.devicesService.updateVolume(this.deviceInfo.InternalId, this.deviceInfo.Volume).pipe(
      tap(o => this.editPropertie('volume')),
      delay(2000),
      tap(o => this.devicesService.refreshDevice()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public lock() {
    this.lockSubscription = this.devicesService.lock(this.deviceInfo.InternalId).pipe(
      tap(error => this.snackbarService.open(error['error']['message'], 'error')),
      catchError(error => { this.devicesService.refreshDevice(); return EMPTY; })
    ).subscribe();
  }

  public unlock() {
    this.unlockSubscription = this.devicesService.unlock(this.deviceInfo.InternalId).pipe(
      tap(o => this.devicesService.refreshDevice()),
      tap(o => this.snackbarService.open(o['error']['message'], 'error'))
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.updateBrightnessSubscription) { this.updateBrightnessSubscription.unsubscribe(); }
    if (this.updateVolumeSubscription) { this.updateVolumeSubscription.unsubscribe(); }
    if (this.lockSubscription) { this.lockSubscription.unsubscribe(); }
    if (this.unlockSubscription) { this.unlockSubscription.unsubscribe(); }
  }

}
